import { ColDef } from 'ag-grid-community';
import { Component, ViewChild } from '@angular/core';
import appConfig from '../../../shared/config/app-config';
import { createColumn, createDateColumn } from '../../../utils/helper';
import { SubscriptionService } from '../../../shared/services/subscription.service';
import { DatatableComponent } from '../../../shared/components/datatable/datatable.component';

@Component({
  selector: 'app-print-subscription',
  templateUrl: './print-subscription.component.html',
  styleUrl: './print-subscription.component.scss'
})
export class PrintSubscriptionComponent {

  settingTilesData: any;

  @ViewChild(DatatableComponent) datatable!: DatatableComponent;

  url = `${appConfig.myAccountBaseUrl}subscription/get-subscribe-user`;

  colDefs: ColDef[] = [
    createColumn('First name', 'name'),
    createColumn('Last name', 'last_name'),
    createColumn('Email', 'email'),
    createColumn('Role', 'job_role'),
    {
      headerName: 'Print vettimes',
      field: 'print_vettimes',
      floatingFilter: true,
      cellRenderer: (params: any) => this.formatSubscriptionStatus(params.value)
    },
    {
      headerName: 'Print vntimes',
      field: 'print_vntimes',
      floatingFilter: true,
      cellRenderer: (params: any) => this.formatSubscriptionStatus(params.value)
    },
    {
      headerName: 'Print VBJ',
      field: 'print_vbj',
      floatingFilter: true,
      cellRenderer: (params: any) => this.formatSubscriptionStatus(params.value)
    },
    createDateColumn('Last activity', 'updated_at'),
  ];

  constructor(private subscriptionService: SubscriptionService) { }

  ngOnInit(): void {
    this.loadSettingTitle();
  }

  loadSettingTitle() {
    this.subscriptionService.getSettingTiles().subscribe((response) => {
      this.settingTilesData = response.data;
    });
  }

  formatSubscriptionStatus(value: number): string {
    return value === 1 ? 'Subscribed' : 'Unsubscribed';
  }
}
